import React,{Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {authenticate,passwordReset,authenticating} from '../../actions/authActions';
import IndicatorButton from '../../components/IndicatorButton';
import Alert from '../../components/Alert';
import {isValidEmail} from '../../utils/Validators';
import {showError,showMessage} from '../../actions/uiActions';

class LoginForm extends Component
{
    state=
    {
        email:'',
        valid_email:true,
        password:'',
        valid_password:true,
        authenticating:false
    }

    componentWillReceiveProps()
    {
        this.setState({authenticating:false,valid_email:true,valid_password:true});
    }

    handleOnChange=(e)=>
    {
        this.setState({[e.target.name]:e.target
        .value,valid_email:true,valid_password:true});
        
    }

    handleOnSubmit=(e)=>
    {
        if(e)
            e.preventDefault();
        const emailIsValid=isValidEmail(this.state.email);

        this.setState({valid_email:emailIsValid,valid_password:this.state.password.length>0});
        
        if(emailIsValid&&this.state.password.length>0)
        {
            this.setState({authenticating:true});
            this.props.authenticate(this.state.email,this.state.password);
        }

    }
    resetPassword=()=>
    {
        this.props.passwordReset();
    }
    
    render()
    {
        return <div className="container login"><div className="row"><div className="col-xl-4 offset-xl-4 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-12"><div className="mat-card animated fadeIn">
        <form onSubmit={this.handleOnSubmit}>
            <div className="form-group nice">
            <input disabled={this.state.authenticating} type="email" name="email" value={this.state.email} onChange={this.handleOnChange} className="form-control branded-dark-input" placeholder="Email Address" />
            {!this.state.valid_email&&<div className="input-error animated zoomIn">Enter a valid email address</div>}
            </div>
            <div className="form-group nice">
            <input disabled={this.state.authenticating} type="password" autoComplete='new-password' name="password" value={this.state.password} onChange={this.handleOnChange} onKeyDown={(event)=>
                {
                    if(event.keyCode==13)
                        this.handleOnSubmit();
                }} className="form-control branded-dark-input" placeholder="Account Password" />
            {!this.state.valid_password&&<div className="input-error animated zoomIn">Enter your account password</div>}
            </div>
        </form>
        <div className="actions">
        <button disabled={this.state.authenticating} onClick={this.resetPassword} className="link align-left ">Forgot password?</button>
        <IndicatorButton disabled={this.state.authenticating} className="btn-primary btn-material" onClick={this.handleOnSubmit}>Sign In</IndicatorButton>
        </div>
        </div></div></div>
        {this.props.auth_failed&&<Alert onClose={this.props.authenticating}>{ this.props.errorMessage || "Error processing request"}</Alert>}
        </div>

    }
}
const mapStateToProps= state =>{
    return {
        authenticating:state.auth.authenticating,
        auth_failed: state.auth.auth_failed,
        errorMessage: state.auth.errorMessage,
        authenticate:authenticate,
        resetPassword: passwordReset,
        
    }};
LoginForm.propTypes=
{
    authenticate: PropTypes.func.isRequired,
    authenticating:PropTypes.func.isRequired,
    auth_failed:PropTypes.bool,
    resetPassword:PropTypes.func.isRequired
};
export default connect(mapStateToProps,{authenticate,passwordReset,authenticating,showError,showMessage})(LoginForm);